import { Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { TableModule } from 'primeng/table';
import { Connection } from '../../interfaces/connection-interface';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ConnectionFormatterService } from '../../services/connection-formatter.service';
import { DeleteModalComponent } from '../../modals/delete-modal/delete-modal.component';
import { Tag } from 'primeng/tag';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'lib-table',
  imports: [
    TableModule,
    InputTextModule,
    ButtonModule,
    InputIconModule,
    IconFieldModule,
    DeleteModalComponent,
    Tag,
    TooltipModule,
    TranslatePipe,
  ],
  templateUrl: './table.component.html',
  styleUrl: './table.component.css',
})
export class TableComponent {
  private formatter = inject(ConnectionFormatterService);

  @Input() connections: Connection[] = [];
  @Output() editConnectionEvent = new EventEmitter<Connection>();
  @Output() deleteConnectionEvent = new EventEmitter<boolean>();

  editConnection(connection: Connection) {
    this.editConnectionEvent.emit(connection);
  }

  deleteConnection(status: boolean) {
    this.deleteConnectionEvent.emit(status);
  }

  getConnectionBadgeClass(type: string): string {
    return this.formatter.getBadgeClass(type);
  }

  getSeverity(type: string): 'success' | 'info' | 'warn' | 'contrast' | 'secondary' | null {
    return this.formatter.getSeverity(type);
  }

  getIcons(type: string) {
    return this.formatter.getConnectionTypeWithIcon(type);
  }
}
